export const isExpandEnabled = ({ selected, editable, expandable }) => {
  if (!selected) return false

  return Boolean(editable || expandable)
}

export const getCurrencySymbol = currency => {
  if (!currency) return ''

  const parts = new Intl.NumberFormat('es', { style: 'currency', currency }).formatToParts(0)

  return parts.find(part => part.type === 'currency').value
}

export const getAmountAdornment = ({ currency, isNegative }) => {
  const symbol = getCurrencySymbol(currency)

  if (isNegative) return `-${symbol}`

  return symbol
}

export const getFormattedAmount = ({ amount, currency, language }) => {
  if (!currency) return `${amount}`

  return new Intl.NumberFormat(language, { style: 'currency', currency }).format(amount)
}

export const getHeaderAmount = ({ amount, isNegative }) => {
  const value = parseFloat(amount)

  if (isNaN(value) || !isNegative) return amount

  return -Math.abs(value)
}
